// extracted by mini-css-extract-plugin
export default {"modal":"create-app_modal__5rGwN"};